<div class="bg-white px-6 py-32 lg:px-8">
  <div class="mx-auto max-w-3xl text-base/7 text-gray-700">
    <h1 class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Terms of Use</h1>
    <p class="text-base/7 font-semibold text-indigo-600">Effective January 1, 2026</p>
    <p class="mt-6 text-xl/8">Welcome to Crown Wash (“Company,” “we,” “our,” or “us”). By accessing our website, requesting a quote, scheduling services, or otherwise using our services, you agree to the following Terms of Use and Service Agreement.</p>
    <div class="mt-10 max-w-2xl text-gray-600">
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">1. Company Information</h2>
      <p class="mt-6">Crown Wash is an exterior cleaning company based in Concord, North Carolina and serving the Charlotte Metro Area.</p>
      <p class="mt-6">Services may include but are not limited to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Soft washing</li>
        <li>Pressure washing</li>
        <li>House washing</li>
        <li>Driveway cleaning</li>
        <li>Sidewalk cleaning</li>
        <li>Curb cleaning</li>
        <li>Gutter exterior washing</li>
        <li>Waste receptacle cleaning</li>
        <li>Roof washing</li>
        <li>Exterior surface restoration</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">2. Estimates & Pricing</h2>
      <p class="mt-6">All estimates provided by Crown Wash are non-binding estimates based on the information available at the time of quoting.</p>
      <p class="mt-6">Final pricing may vary based on:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Property size</li>
        <li>Surface condition</li>
        <li>Accessibility</li>
        <li>Severity of buildup or staining</li>
        <li>Safety conditions</li>
        <li>Additional requested services</li>
        <li>Additional work performed outside the original scope as required</li>
        <li>Permitting or regulatory requirements</li>
        <li>Time required to complete the work</li>
      </ul>
      <p class="mt-6">Crown Wash reserves the right to adjust pricing upon on-site inspection prior to beginning work.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">3. Scheduling & Weather</h2>
      <p class="mt-6">Exterior cleaning services are weather-dependent.</p>
      <p class="mt-6">Crown Wash reserves the right to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Reschedule services due to weather</li>
        <li>Unsafe conditions</li>
        <li>Equipment issues</li>
        <li>Other operational circumstances</li>
      </ul>
      <p class="mt-6">Customers will be notified as soon as reasonably possible regarding scheduling changes.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">4. Property Access Requirements</h2>
      <p class="mt-6">Customers are responsible for providing:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Access to the property</li>
        <li>Access to exterior water connections</li>
        <li>Access to all requested service areas</li>
        <li>A reasonably safe work environment</li>
      </ul>
      <p class="mt-6">Customers agree to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Secure pets</li>
        <li>Close windows and doors</li>
        <li>Remove fragile items</li>
        <li>Notify Crown Wash of any known hazards or damage prior to service</li>
        <li>Ensure that all vehicles are moved from driveways and service areas</li>
        <li>Ensure that all outdoor furniture and belongings are removed from service areas</li>
        <li>Ensure that all requested service areas are accessible and free of obstructions</li>
        <li>Ensure that all edges of sidewalks, patios, driveways, and similar surfaces are clear of debris and growth</li>
      </ul>
      <p class="mt-6"></p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">5. Pre-Existing Conditions & Surface Risks</h2>
      <p class="mt-6">Customer acknowledges that exterior cleaning may expose pre-existing damage, defects, or deterioration including but not limited to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Oxidation</li>
        <li>Loose siding</li>
        <li>Cracked concrete</li>
        <li>Failing paint</li>
        <li>Deteriorated caulking</li>
        <li>Loose mortar</li>
        <li>Brittle roofing materials</li>
        <li>Improperly sealed windows</li>
        <li>Damaged gutters</li>
        <li>Warped wood</li>
        <li>Weakened surfaces</li>
        <li>Hidden damage concealed by dirt or buildup</li>
        <li>Structural issues</li>
        <li>Hidden leaks</li>
        <li>Pre-existing stains or discoloration</li>
        <li>Improperly maintained surfaces</li>
        <li>Age-related deterioration</li>
        <li>Manufacturer defects</li>
        <li>Improper installation</li>
        <li>Workmanship issues</li>
        <li>Other pre-existing conditions</li>
      </ul>
      <p class="mt-6">Crown Wash is not responsible for damages resulting from pre-existing conditions, normal wear and tear, age-related deterioration, or improperly maintained surfaces.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">6. Oxidation Disclaimer</h2>
      <p class="mt-6">Certain exterior surfaces may experience oxidation or fading over time. Cleaning may reveal or expose oxidation that was previously hidden by dirt or buildup.</p>
      <p class="mt-6">Customer acknowledges that oxidation-related appearance changes are not considered damage caused by Crown Wash.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">7. Roof Cleaning Disclaimer</h2>
      <p class="mt-6">Roof cleaning services may expose:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Loose shingles</li>
        <li>Brittle roofing materials</li>
        <li>Granule loss</li>
        <li>Deteriorated flashing</li>
        <li>Pre-existing roof damage</li>
      </ul>
      <p class="mt-6">Crown Wash is not responsible for issues related to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Roof age</li>
        <li>Manufacturer defects</li>
        <li>Improper installation</li>
        <li>Pre-existing deterioration</li>
        <li>Improper maintenance</li>
        <li>Normal wear and tear</li>
        <li>Pre-existing damage</li>
        <li>Age-related deterioration</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">8. Chemical Use & Landscaping Disclaimer</h2>
      <p class="mt-6">Crown Wash utilizes professional cleaning agents and soft wash solutions during service.</p>
      <p class="mt-6">While reasonable precautions are taken to protect landscaping and surrounding property, Customer acknowledges that:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Exterior cleaning involves chemical application</li>
        <li>Environmental conditions may affect results</li>
        <li>Certain vegetation may be sensitive to cleaning agents</li>
      </ul>
      <p class="mt-6">Crown Wash is not responsible for:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Pre-existing plant stress</li>
        <li>Improper irrigation</li>
        <li>Hidden landscaping issues</li>
        <li>Naturally sensitive vegetation</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">9. Wastewater & Environmental Conditions</h2>
      <p class="mt-6">Customer acknowledges that certain services may generate runoff or wastewater.</p>
      <p class="mt-6">Customer is responsible for compliance with any local water use or drainage regulations.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">10. Payment Terms</h2>
      <p class="mt-6">Payment is due upon completion of service unless otherwise agreed in writing.</p>
      <p class="mt-6">Accepted payment methods may include:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Cash</li>
        <li>Credit/debit cards</li>
        <li>Electronic payments</li>
        <li>ACH transfers</li>
        <li>Invoicing</li>
      </ul>
      <p class="mt-6">At the sole discretion of Crown Wash, late balances may be subject to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Late fees</li>
        <li>Collection costs</li>
        <li>Interest on overdue amounts, fees, and costs incurred in connection with collections</li>
        <li>Liens</li>
        <li>Reasonable attorney's fees where permitted by law</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">11. Cancellations</h2>
      <p class="mt-6">Customers must provide reasonable notice for cancellations or rescheduling requests.</p>
      <p class="mt-6">Crown Wash reserves the right to charge cancellation fees for last-minute cancellations, inaccessible properties, or no-show appointments.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">12. Media Release</h2>
      <p class="mt-6">Customer grants Crown Wash permission to photograph and/or record the property before, during, and after service for:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Documentation</li>
        <li>Quality assurance</li>
        <li>Marketing</li>
        <li>Advertising</li>
        <li>Website use</li>
        <li>Social media promotion</li>
      </ul>
      <p class="mt-6">Crown Wash will make reasonable efforts to avoid displaying personally identifiable information.</p>
      <p class="mt-6">Customers may opt-out of marketing use by submitting written notice prior to service.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">13. Digital and Electronic Communications</h2>
      <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">13.1 Email Communications</h3>
      <p class="mt-3">By providing your email address and agreeing to the Terms of Service and Privacy Policy, you consent to receive:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Emails</li>
      </ul>
      <p class="mt-3">These emails may include:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Contact Request Form follow-ups</li>
          <li>Quotes</li>
          <li>Appointment confirmations</li>
          <li>Appointment reminders</li>
          <li>Arrival updates</li>
          <li>Service updates</li>
          <li>Billing notifications</li>
          <li>Customer support messages</li>
      </ul>
      <p class="mt-3">You may opt-out at any time by clicking the unsubscribe link in our emails or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
      <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">13.2 SMS/MMS Communications</h3>
      <p class="mt-3">
            Providing a mobile telephone number, selecting text messaging as a preferred contact method, submitting a contact or quote request, or accepting the Terms of Service and Privacy Policy does not, by itself, constitute consent to receive recurring SMS or MMS messages. 
            Crown Wash sends recurring SMS or MMS messages only when you separately and affirmatively opt in through an optional, initially unselected SMS consent control that requires a separate affirmative selection on our website or through another opt-in process that clearly discloses the specific text messages you are agreeing to receive.
            Consent to receive text messages is optional and is not a condition of purchasing or receiving any property, goods, or services from Crown Wash.
      </p>
      <p class="mt-3">When you opt in, Crown Wash may collect and maintain:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Your mobile telephone number</li>
          <li>Your SMS consent status</li>
          <li>The date and time consent was provided</li>
          <li>The webpage, form, or other source through which consent was provided</li>
          <li>The consent language presented when you opted in</li>
          <li>Your messaging preferences</li>
          <li>History of text messages conversations between you and Crown Wash</li>
          <li>Opt-out and help requests</li>
      </ul>
      <p class="mt-3">
          SMS/MMS Communications consent detailed in this section applies to non-marketing, customer care related messages.
          Any marketing or promotional messages sent by Crown Wash will be subject to separate consent and opt-in requirements, and will not be sent without your prior consent.
      </p>
      <p class="mt-3">If you separately and affirmatively opt-in to SMS communications, you consent to receive:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>SMS/MMS messages</li>
      </ul>
      <p class="mt-3">Related to:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Contact Request Form follow-ups</li>
          <li>Quotes</li>
          <li>Appointment confirmations</li>
          <li>Appointment reminders</li>
          <li>Arrival updates</li>
          <li>Service updates</li>
          <li>Billing notifications</li>
          <li>Payment confirmations</li>
          <li>Customer support messages</li>
          <li>Post service appointment follow-ups</li>
      </ul>
      <p class="mt-3">Message and data rates may apply. You may opt-out at any time by replying “STOP” or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
      <p class="mt-3">You may also request help by replying “HELP” or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
      <p class="mt-3">Message frequency varies based on your quote requests, appointments, services, customer-initiated communications, and account activity.</p>
      <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">13.3 Voice Communications</h3>
      <p class="mt-3">By providing your phone number and agreeing to the Terms of Service and Privacy Policy, you consent to receive:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Voice calls</li>
          <li>Voicemail</li>
      </ul>
      <p class="mt-3">Related to:</p>
      <ul class="mt-2 list-disc list-inside">
          <li>Contact Request Form follow-ups</li>
          <li>Quotes</li>
          <li>Appointment confirmations</li>
          <li>Appointment reminders</li>
          <li>Arrival updates</li>
          <li>Service updates</li>
          <li>Billing notifications</li>
          <li>Customer support messages</li>
      </ul>
      <p class="mt-3">Message and data rates may apply. You may opt-out at any time by contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">14. Limitation of Liability</h2>
      <p class="mt-6">To the fullest extent permitted by law, Crown Wash's total liability for any claim arising from services or website use shall not exceed the total amount paid by Customer for the specific service giving rise to the claim.</p>
      <p class="mt-6">Under no circumstances shall Crown Wash be liable for:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Indirect damages</li>
        <li>Incidental damages</li>
        <li>Consequential damages</li>
        <li>Lost profits</li>
        <li>Emotional distress</li>
        <li>Property conditions outside the Company's control</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">15. Indemnification</h2>
      <p class="mt-6">Customer agrees to indemnify and hold harmless Crown Wash, its owners, employees, contractors, and affiliates from claims arising from:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Unsafe property conditions</li>
        <li>Inaccurate customer information</li>
        <li>Pre-existing defects</li>
        <li>Misuse of services</li>
        <li>Customer negligence</li>
        <li>Customer's breach of these Terms</li>
        <li>Customer's violation or breach of any third-party agreements, contracts, or obligations</li>
        <li>Customer's violation of any applicable law or regulation</li>
        <li>Customer's infringement of any third-party rights</li>
        <li>Customer's failure to comply with safety guidelines</li>
        <li>Customer's failure to provide necessary access or information</li>
        <li>Customer's failure to maintain the property after service</li>
        <li>Customer's failure to disclose known hazards or damage</li>
        <li>Customer's failure to secure pets or belongings</li>
        <li>Customer's failure to ensure accessibility of service areas</li>
        <li>Local, state, or federal regulations, ordinances, codes, policies, restrictions, or guidelines</li>
      </ul>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">16. Arbitration & Governing Law</h2>
      <p class="mt-6">Any dispute arising from services provided by Crown Wash shall be resolved through binding arbitration in Cabarrus County, North Carolina, except where prohibited by law.</p>
      <p class="mt-6">These Terms shall be governed by the laws of the State of North Carolina.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">17. Website Use</h2>
      <p class="mt-6">Users agree not to:</p>
      <ul class="mt-2 list-disc list-inside">
        <li>Misuse the website</li>
        <li>Attempt unauthorized access</li>
        <li>Upload malicious content</li>
        <li>Interfere with website functionality</li>
      </ul>
      <p class="mt-6">All website content, branding, graphics, and intellectual property belong to Crown Wash unless otherwise stated.</p>
      <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">18. Changes to Terms</h2>
      <p class="mt-6">Crown Wash reserves the right to modify these Terms at any time without prior notice.</p>
      <p class="mt-6">Updated versions will be posted to the website with the revised effective date.</p>
      <p class="mt-6">Continued use of services or the website after changes constitutes acceptance of the new Terms.</p>
    </div>
  </div>
</div>
